import { styled } from '@mui/system';
import { Typography } from '@mui/material';

export const InformationContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  gap: '1px',
});

export const InformationTypography = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: theme.palette.text.secondary,
  '& > span': {
    fontWeight: 500,
    color: theme.palette.text.primary,
    marginRight: '5px',
  },
}));
